import React, { FC, ReactNode } from "react";
import { StyleProp, ViewStyle } from "react-native";
import { COLOR, DISPLAY, FLEX_DIRECTION, SPACE, View } from "@lookiero/aurora";

interface InfoBannerProps {
  readonly children: ReactNode;
  readonly style?: StyleProp<ViewStyle>;
  readonly color?: COLOR;
}

const InfoBanner: FC<InfoBannerProps> = ({ children, style, color = COLOR.BG_WARNING_LIGHT }) => (
  <View
    backgroundColor={color}
    display={DISPLAY.FLEX}
    flexDirection={FLEX_DIRECTION.ROW}
    padding={SPACE.SPACE_4}
    style={style}
  >
    {children}
  </View>
);

export { InfoBanner };
